// ==========================================
// Admin API (JWT auth) - mounted at root
// ==========================================
export const AUTH_SIGNUP = 'user';
export const AUTH_LOGIN = 'user/sign-in';
export const USER_INFO = 'user/me';
export const PROJECT = 'project';
export const PROJECTS = 'project-user/all';
export const API_KEY = 'api-key';

// ==========================================
// E-IMZO Authentication endpoints
// ==========================================
export const EIMZO_CREATE_CHALLENGE = 'embed/v1/auth/eimzo/challenge';
export const EIMZO_GET_CHALLENGE = 'embed/v1/auth/eimzo/challenge/{request_id}';
export const EIMZO_VERIFY = 'embed/v1/auth/eimzo/verify';
export const EIMZO_CERTIFICATES = 'embed/v1/auth/eimzo/certificates';

// ==========================================
// Embed API (embed token) - prefix: embed/v1/
// ==========================================
export const EXCHANGE_EMBED_TOKEN = 'embed/v1/embed-tokens';
export const EMBED_USER_ME = 'embed/v1/me';
// Unified node endpoints (files + folders share one model)
export const NODE_CHILDREN = 'embed/v1/node/children';
export const SEARCH = 'embed/v1/search';
export const FILE_INDEX_STATUS = 'embed/v1/file/index-status';
export const NODE_TRASH = 'embed/v1/node/trash';
export const NODE_COUNTS = 'embed/v1/node/counts';
export const NODE_RESTORE_TRASH = 'embed/v1/node/{node_id}/restore-from-trash';
export const NODE_PURGE = 'embed/v1/node/{node_id}/purge';
export const NODE = 'embed/v1/node/{id}';
export const NODE_FOLDER_CREATE = 'embed/v1/node/folder';
export const NODE_BULK_MOVE = 'embed/v1/node/bulk-move';
export const NODE_BULK_DELETE = 'embed/v1/node/bulk-delete';
export const NODE_RESTORE = 'embed/v1/node/{id}/restore';
export const NODE_OWNER = 'embed/v1/node/{id}/owner';
export const NODE_RESTORE_TARGET = 'embed/v1/node/{id}/restore-target';
export const NODE_DELETE_PREVIEW = 'embed/v1/node/{id}/delete-preview';
export const FILES = 'embed/v1/file';
export const UNIQUE_FILE = 'embed/v1/file';
export const DELETE_DOCUMENT = 'embed/v1/document/{id}';
export const FILES_BULK_COPY = 'embed/v1/file/bulk-copy';
export const FILES_ARCHIVED = 'embed/v1/file/archived';
export const FILE_ARCHIVE = 'embed/v1/file/{file_id}/archive';
export const FILE_RESTORE = 'embed/v1/file/{file_id}/restore';
export const FILE_RESTORE_TARGET = 'embed/v1/file/{file_id}/restore-target';
export const FILE_UPDATE = 'embed/v1/file/{id}';
export const SHARE_FILE = 'embed/v1/share';
export const UNSHARE_FILE = 'embed/v1/unshare';
export const SHARE_USERS = 'embed/v1/share/all-users';
export const SHARED_USERS_LIST = 'embed/v1/share/shared-users';
// Who has access to a node and how, with the caller's own access and the
// project's sharing policy (the share dialog's one read).
export const NODE_SHARES = 'embed/v1/share/node/{id}';
// One share: PATCH its options, DELETE it.
export const SHARE_ITEM = 'embed/v1/share/{id}';
export const RECEIVED_SHARES = 'embed/v1/share/received';
export const SENT_SHARES = 'embed/v1/share/sent';
export const FILE_ACTION_COUNT = 'embed/v1/file/action-count';
export const FILE_CONTENT = 'embed/v1/file/{id}/content';
export const FILE_VERSIONS = 'embed/v1/file/{id}/versions';
export const FILE_VERSION_UPLOAD = 'embed/v1/file/{id}/version';
export const FILE_VERSION_CONTENT = 'embed/v1/file/{id}/version/{version}/content';
export const FILE_VERSION_RESTORE = 'embed/v1/file/{id}/version/{version}/restore';
export const FILE_VERSION_RENAME = 'embed/v1/file/{id}/version/{version}';
// A person's lock on a file: PUT {reason, ref?} locks, DELETE unlocks.
export const FILE_LOCK = 'embed/v1/file/{id}/lock';
// Which of a template-made file's placeholders are still empty (read from the
// saved bytes) — what the signing policy `placeholders` checks.
export const FILE_PLACEHOLDERS_STATUS = 'embed/v1/file/{id}/placeholders/status';

// Clone endpoint
export const FILE_CLONE = 'embed/v1/file/{id}/clone';
export const FILE_SHARE_LINK = 'embed/v1/file/{id}/share-link';

// Activity endpoint
export const FILE_ACTIVITY = 'embed/v1/file/{id}/activity';

// Comments endpoints
export const FILE_COMMENTS = 'embed/v1/file/{id}/comments';
export const COMMENT_UPDATE = 'embed/v1/comments/{id}';
export const COMMENT_DELETE = 'embed/v1/comments/{id}';
export const COMMENT_RESOLVE = 'embed/v1/comments/{id}/resolve';
export const COMMENT_UNRESOLVE = 'embed/v1/comments/{id}/unresolve';

export const FILE_GENERATE_BLANK = 'embed/v1/file/generate/blank';
export const PROJECT_POLICIES = 'embed/v1/project/policies';

// E-IMZO Direct Signing (prepare → sign in the browser → timestamp → complete)
export const EIMZO_SIGN_PREPARE = 'embed/v1/sign/eimzo/prepare';
export const EIMZO_SIGN_TIMESTAMP = 'embed/v1/sign/eimzo/timestamp';
export const EIMZO_SIGN_COMPLETE = 'embed/v1/sign/eimzo/complete';
export const EIMZO_SIGN_SIGNATURES = 'embed/v1/sign/eimzo/files/{file_id}/signature';
export const EIMZO_SIGN_REVERIFY = 'embed/v1/sign/eimzo/files/{file_id}/reverify';
export const E_IMZO_DOCUMENTS = 'embed/v1/document';

// Unified workflow (agreement approval + E-IMZO signer setup).
// participants: POST adds, DELETE removes, PATCH /{participant_id} updates.
export const WORKFLOW = 'embed/v1/workflow/file/{file_id}';
export const WORKFLOW_PARTICIPANTS = 'embed/v1/workflow/file/{file_id}/participants';
export const WORKFLOW_PARTICIPANT = 'embed/v1/workflow/file/{file_id}/participants/{participant_id}';
export const WORKFLOW_RESPOND = 'embed/v1/workflow/file/{file_id}/respond';
export const WORKFLOW_DECLINE = 'embed/v1/workflow/file/{file_id}/decline';
export const WORKFLOW_WITHDRAW = 'embed/v1/workflow/file/{file_id}/withdraw';
// Signing rendition + verification artefacts (binary — fetch as blobs).
export const WORKFLOW_RENDITION = 'embed/v1/workflow/file/{file_id}/rendition';
export const WORKFLOW_QR = 'embed/v1/workflow/file/{file_id}/qr.png';
export const WORKFLOW_PKCS7 = 'embed/v1/workflow/file/{file_id}/pkcs7';
export const WORKFLOW_SIGNATURE_SHEET = 'embed/v1/workflow/file/{file_id}/signature-sheet';
export const WORKFLOW_VERIFICATION_VIEWS = 'embed/v1/workflow/file/{file_id}/verification-views';

// Public verification page data (no auth required; a docs or guest JWT unlocks more).
export const VERIFY = 'verify/{code}';
// Picker support: project users + their registered E-IMZO certs
export const WORKFLOW_USERS_WITH_CERTS = 'embed/v1/workflow/users-with-certs';

// Atomic document-type enrollment (one-way: ordinary -> agreement | signed)
export const ENROLL_SIGNED = 'embed/v1/file/{file_id}/document-type/signed';
export const ENROLL_AGREEMENT = 'embed/v1/file/{file_id}/document-type/agreement';

// ==========================================
// Guest Share (public link sharing)
// ==========================================
export const GUEST_SHARE_LINK = 'embed/v1/share/guest-share/link';
export const GUEST_SHARE_RESOURCE = 'guest-share/resource';
// A folder guest link: what is inside a folder it reaches, and one node.
export const GUEST_SHARE_CHILDREN = 'guest-share/children';
export const GUEST_SHARE_NODE = 'guest-share/node';
// A node's guest links: GET ?node_id=, POST to make one; /{id}: PATCH, DELETE.
export const GUEST_LINKS = 'embed/v1/share/guest-links';
export const GUEST_LINK = 'embed/v1/share/guest-links/{id}';

// ==========================================
// Guest Auth (EIMZo auth for guest users)
// ==========================================
export const GUEST_AUTH_CHALLENGE = 'guest-auth/challenge';
export const GUEST_AUTH_VERIFY = 'guest-auth/verify';

// Guest document lookup (to resolve document_id from file_id for signers)
export const GUEST_DOCUMENT_BY_FILE = 'embed/v1/document';

// ==========================================
// WOPI / Collabora Online
// ==========================================
export const WOPI_TOKEN = 'embed/v1/wopi/token/{id}';
export const WOPI_TOKEN_FROM_SHARE = 'embed/v1/wopi/token/from-share';
export const WOPI_DISCOVERY = 'embed/v1/wopi/discovery';

// ==========================================
// Template library (project-level, never in the folder tree)
// ==========================================
export const TEMPLATES = 'embed/v1/templates';
export const TEMPLATE = 'embed/v1/templates/{id}';
export const TEMPLATE_BLANK = 'embed/v1/templates/blank';
export const TEMPLATE_UPLOAD = 'embed/v1/templates/upload';
// Private copy of a template into my templates (placeholders come along).
export const TEMPLATE_DUPLICATE = 'embed/v1/templates/{id}/duplicate';
// Create a document from a template (clone + placeholder definitions copied).
export const TEMPLATE_INSTANTIATE = 'embed/v1/templates/{id}/instantiate';
// A template's (or document's) placeholder rows, with the record it is about.
export const TEMPLATE_PLACEHOLDERS = 'embed/v1/file/{id}/placeholders';
// Modules whose records may fill templates, and where they answer
// (backend docs/template-data.md).
export const TEMPLATE_SOURCES = 'embed/v1/template-sources';
